import {
  Button,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";

const ChannelFilter = ({
  setFilter,
  value,
  setValue,
  excludedChannels = [],
}) => {
  // const [value, setValue] = useState('');

  const handleChange = (event) => {
    if (event.target.value == "any") {
      setValue((prev) => ({
        ...prev,
        channel: undefined,
      }));
      setFilter((prev) => ({
        ...prev,
        channel: undefined,
        page: 1,
      }));
      return;
    }

    setValue((prev) => ({
      ...prev,
      channel: event.target.value,
    }));
    setFilter((prev) => ({
      ...prev,
      channel: event.target.value,
      page: 1,
    }));
  };

  return (
    <FormControl>
      <Select
        autoWidth
        displayEmpty
        size="small"
        value={value.channel || ""}
        renderValue={(selected) => {
          if (selected.length === 0) {
            return <Typography variant="big">Channel</Typography>;
          }

          return selected;
        }}
        sx={{
          borderRadius: "16px",
          "& .MuiOutlinedInput-notchedOutline": {
            boxShadow: "none",
            border: value.channel && "1px solid",
            borderColor: value.channel && "primary.main",
            color: value.channel ? "primary.main" : "grey.main",
          },
        }}
        onChange={(event) => handleChange(event)}
        id="demo-simple-select"
      >
        <MenuItem value={"any"}>Any</MenuItem>
        {!excludedChannels.includes("mobile") && (
          <MenuItem value={"mobile"}>Mobile app</MenuItem>
        )}
        {!excludedChannels.includes("plate") && (
          <MenuItem value={"plate"}>Plate collection</MenuItem>
        )}
        {!excludedChannels.includes("event") && (
          <MenuItem value={"event"}>Event</MenuItem>
        )}
        {!excludedChannels.includes("envelope") && (
          <MenuItem value={"envelope"}>Envelope</MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default ChannelFilter;
